<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <div>
            <div class="kgr-row">
                <div>
                    <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--top kgr-row">
                        <div class="kgr-postfix__fluid">
                            <kgr-view-picker
                                :value="view"
                                @post-input="updateView"
                            />
                        </div>
                        <div
                            v-if="isCreatable"
                            class="kgr-postfix__fixed"
                        >
                            <a
                                v-t="'Neue Abteilung hinzufügen'"
                                class="kgr-button kgr-button--accent"
                                :href="createUrl"
                            ></a>
                        </div>
                        <div class="kgr-postfix__fixed">
                            <kgr-print-button />
                        </div>
                    </div>

                    <div class="kgr grid kgr-grid--inline kgr-grid--gutters kgr-row">
                        <div class="kgr-grid__cell">
                            <label class="kgr-inputGroup">
                                <div
                                    v-t="'search'"
                                    class="kgr-inputGroup__label"
                                ></div>
                                <input
                                    v-model="filter"
                                    type="text"
                                    class="kgr-input"
                                />
                            </label>
                        </div>

                        <div
                            v-if="view === 'grid'"
                            class="kgr-grid__cell animated fadeIn"
                        >
                            <label class="kgr-inputGroup">
                                <div
                                    v-t="'sort'"
                                    class="kgr-inputGroup__label"
                                ></div>
                                <kgr-department-sort-select
                                    :value="sort"
                                    @post-input="updateSort"
                                />
                            </label>
                        </div>
                    </div>
                </div>

                <kgr-department-child-departments-data-provider
                    v-slot="departmentsScope"
                    :department-id="departmentId"
                >
                    <div>
                        <kgr-empty-data
                            v-if="departmentsScope.data.length === 0"
                            :value="$t('Es wurden noch keine Abteilungen angelegt.')"
                        />

                        <kgr-departments-list
                            v-else
                            :departments="departmentsScope.data"
                            :filter="filter"
                            :sort="sort"
                            :view="view"
                            :include-children="true"
                        />
                    </div>
                </kgr-department-child-departments-data-provider>
            </div>
        </div>
    </kgr-form-scaffold>
</template>

<script>
import DepartmentChildDepartmentsDataProvider from '../../components/data-provider/DepartmentChildDepartmentsDataProvider';
import EmptyData from '../../components/common/EmptyData';
import KgrDepartmentSortSelect from '../../components/departments/SortSelect';
import KgrDepartmentsList from '../../components/departments/DepartmentsList';
import KgrFormScaffold from '../../components/common/form/FormScaffold';
import PrintButton from '../../components/common/form/button/PrintButton';
import ViewPicker from '../../components/common/form/picker/ViewPicker';

const DEPARTMENTS_OVERVIEW_VIEW = 'kgr:child-departments:overview:view';
const DEPARTMENTS_OVERVIEW_SORT = 'kgr:child-departments:overview:sort';

export default {
    components: {
        KgrDepartmentsList,
        KgrDepartmentSortSelect,
        'kgr-department-child-departments-data-provider': DepartmentChildDepartmentsDataProvider,
        'kgr-empty-data': EmptyData,
        'kgr-print-button': PrintButton,
        'kgr-view-picker': ViewPicker,
        'kgr-form-scaffold': KgrFormScaffold,
    },
    props: {
        departmentId: {
            type: Number,
            required: true,
        },
        overviewUrl: {
            type: String,
            required: true,
        },
        createUrl: {
            type: String,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            filter: null,
            sort: null,
            view: 'grid',
        };
    },
    created() {
        const view = localStorage.getItem(DEPARTMENTS_OVERVIEW_VIEW);
        if (view !== null && view !== '') {
            this.view = view;
        }

        this.sort = localStorage.getItem(DEPARTMENTS_OVERVIEW_SORT);
    },
    methods: {
        updateView(view) {
            this.view = view;

            if (view !== null) {
                localStorage.setItem(DEPARTMENTS_OVERVIEW_VIEW, view);
            } else {
                localStorage.removeItem(DEPARTMENTS_OVERVIEW_VIEW);
            }
        },
        updateSort(sort) {
            this.sort = sort;

            if (sort !== null) {
                localStorage.setItem(DEPARTMENTS_OVERVIEW_SORT, sort);
            } else {
                localStorage.removeItem(DEPARTMENTS_OVERVIEW_SORT);
            }
        },
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
